import { render, staticRenderFns } from "./BaseDisclaimer.vue?vue&type=template&id=48e4365e"
import script from "./BaseDisclaimer.vue?vue&type=script&lang=js"
export * from "./BaseDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./BaseDisclaimer.vue?vue&type=style&index=0&id=48e4365e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports